module.exports = __webpack_public_path__ + "c6e0745bc5b1558c523643308c5920d4.svg";